app.add({
  onLoad: function() {
    $('.ga-event').click(function(){
        var $trigger = $(this);
        var item = $trigger.attr('data-event-item');
        var event = $trigger.attr('data-event');
        var label = $trigger.attr('data-event-label');
        if (event && item) {
            ga('send', 'event', item, event, label);
        }
    });

    $('#donate-button').click(function() {
      $('form#paypal').submit();
    });

    $('.donation-confirm').click(function() {
        var $modal = $('.donation-modal');
        if ($modal.length) {
            $modal.modal();
            ga('send', 'event', 'Donation', ' donation-modal');
        }
    });

    $('.trigger__hover').hover(function() {
        $($(this).attr('data-hover')).addClass('hovered');
    }, function() {
        $($(this).attr('data-hover')).removeClass('hovered');
    });
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/global.js